import { Typography } from "@mui/material";
import React from "react";
import { useState, useEffect } from "react";
import colors from "../colors";

const Timer = ({ duration, onTimerCompleted }) => {
  const [time, setTime] = useState(duration);

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setTime(time - 1000);
    }, 1000);
    return function cleanup() {
      clearTimeout(timeoutId);
    };
  }, [time]);

  const getFormattedTime = (milliseconds) => {
    let totalSeconds = parseInt(Math.floor(milliseconds / 1000));
    let totalMinutes = parseInt(Math.floor(totalSeconds / 60));

    let seconds = parseInt(totalSeconds % 60);
    let minutes = parseInt(totalMinutes % 60);

    const counter = () => {
      return (
        <Typography
          sx={{ fontFamily: "GerberaMedium", color: colors.darkBlue }}
        >{`${minutes} : ${seconds}`}</Typography>
      );
    };

    if (minutes < 0) {
      onTimerCompleted(true);
    } else {
      return counter();
    }
  };
  return <div>{getFormattedTime(time)}</div>;
};

export default Timer;
